import React from 'react'
import Navbar from '../Miscellaneous/Navbar'
import { NavLink } from 'react-router'
import Footer from '../Miscellaneous/Footer'
import SubContact from '../Miscellaneous/SubContact'

const Contact = () => {
    document.title = "Contact - Roop Sweets"

    
    return (
        <>
            <Navbar />
            {/* <SubContact/> */}
            <div className='directiondiv'>
                <img className='gif' src="gif.gif" alt="map" />
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3447.7826255549935!2d75.090472175884!3d30.214751010480956!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3910d1d9760e97b9%3A0x3cc477a5c0f0b4c4!2sRoop%20Sweet%20Shop%20-%20Sweet%20shop%2F%20Dairy%20%26%20Sweet%20Products%20in%20Bathinda!5e0!3m2!1sen!2sin!4v1734252796240!5m2!1sen!2sin"
                    width="100%"
                    height="650px"
                    style={{ border: 0 }}
                    allowFullScreen
                    referrerPolicy="no-referrer-when-downgrade"
                    className='map'
                    title='Shop location'
                />

                <div className='timingdiv'>
                    <h2>Working Hours:-</h2>
                    <p>Summer: All days:- 5:30AM-10:00PM</p>
                    <p>Winter: All days :- 6:00AM-9:30PM</p>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default Contact
